var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-block-list-accordion-shared-items"},[_c('BlockList',{attrs:{"block-list":_vm.elements}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }